<template>
  <div>
    <div class="sidebar"
        @click="mobileConfig = !mobileConfig"
        :class="{open: mobileConfig}"
    >
      <img :src="getImage('chevron-left-solid.svg')" alt="">
      <span>{{ title }}</span>
    </div>

    <transition name="fade-move-left" mode="out-in">
      <div class="mobile-configuration" v-if="mobileConfig">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'Sidebar',

  props: {
    title: String,
  },

  data() {
    return {
      mobileConfig: false,
    }
  },
}
</script>
<style scoped lang="scss">
.fade-move-left-enter-active, .fade-move-left-leave-active {
  transition: all .25s ease;
}

.fade-move-left-enter, .fade-move-left-leave-to /* .fade-leave-active below version 2.1.8 */
{
  transform: translateX(-100%);
}

.sidebar {
  display: flex;
  justify-content: space-between;
  background: #3DB0C7;
  color: #fff;
  position: fixed;
  left: 0;
  top: 100px;
  padding: 0 15px;
  font-family: neue-haas-grotesk-text, sans-serif;
  font-size: 13px;
  transform-origin: top right;
  transform: translateX(-100%) rotate(270deg);
  height: 30px;
  line-height: 30px;
  width: 200px;
  transition: all .3s ease;
  z-index: 2;

  img {
    width: 16px;
    height: 24px;
    margin-top: 4px;
    transform: rotate(270deg);
  }

  &.open {
    left: 100%;
    transform: translateX(-100%) rotate(270deg) translateY(-100%);

    img {
      transform: rotate(90deg);
      margin-bottom: 4px;
    }
  }
}

.mobile-configuration {
  position: fixed;
  top: 80px;
  right: 30px;
  left: 0;
  bottom: 0;
  z-index: 99;
  overflow: scroll;
  box-shadow: 0 5px 15px rgba(0, 0, 0, .1);
  background-color: #f9f9f9;

  .image-container {
    position: relative;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 275px;
      min-width: 80%;
      height: auto;
      max-height: 80vh;
      object-fit: contain;
      object-position: center;
    }
  }
}
</style>
